import React, { useState, useEffect } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { Input } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useLoader } from "../../../../_helper/LoaderContext";
import { getStateMaster } from "../../../PharmacySuppliers/SupplierService";

export const NewCustomerModal = ({
	t,
	show,
	onHide,
	newCustomerData,
	onChange,
	errors,
	onSubmit,
}) => {
	const { setLoading } = useLoader();

	/** Fixed Country */
	const selectedCountry = { value: "India", label: "India" };

	const [statesList, setStatesList] = useState([]);
	const [selectedState, setSelectedState] = useState(null);

	/** Fetch states on modal open */
	useEffect(() => {
		if (show) fetchStates();
	}, [show]);

	const fetchStates = async () => {
		try {
			setLoading(true);
			const res = await getStateMaster({ country: "India" });

			if (res?.data?.status === "success") {
				const options = res.data.data.map((state) => ({
					value: state.State,
					label: state.State,
					gstCode: state.gstCode,
				}));
				setStatesList(options);
			}
		} catch (err) {
			toast.warning(t("Failed to load states"));
		} finally {
			setLoading(false);
		}
	};

	/** State selection */
	const handleStateChange = (selectedOption) => {
		setSelectedState(selectedOption);

		onChange({
			state: selectedOption?.label || "",
			stateCode: selectedOption?.gstCode || "",
		});
	};

	const handleModalHide = () => {
		setSelectedState(null);
		onHide();
	};

	// reset state
	useEffect(() => {
		if (!show) {
			setSelectedState(null);
			newCustomerData.state = "";
			newCustomerData.stateCode = "";
		}
	}, [show]);

	return (
		<Modal show={show} onHide={handleModalHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>{t("Create New Customer")}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form>
					{/* Name */}
					<Form.Group className="mb-3">
						<Form.Label>
							{t("Name")} <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							type="text"
							value={newCustomerData.name}
							onChange={(e) => onChange({ name: e.target.value })}
							isInvalid={!!errors.name}
							placeholder={t("Enter customer name")}
						/>
						<Form.Control.Feedback type="invalid">
							{errors.name}
						</Form.Control.Feedback>
					</Form.Group>

					{/* Mobile */}
					<div className="mb-3">
						<label className="form-label">
							{t("Mobile Number")} <span className="text-danger">*</span>
						</label>
						<PhoneInput
							country="in"
							value={`${newCustomerData.phoneCode || ""}${newCustomerData.mobileNumber || ""}`}
							onChange={(value, data) =>
								onChange({
									mobileNumber: value.replace(data.dialCode, ""),
									phoneCode: `+${data.dialCode}`,
								})
							}
						/>
						{errors.mobileNumber && (
							<div className="text-danger mt-1">{errors.mobileNumber}</div>
						)}
					</div>

					<Row>
						{/* Country (Disabled) */}
						<Col md={6}>
							<div className="mb-3">
								<label className="form-label">{t("Country")}</label>
								<Input value="India" disabled />
							</div>
						</Col>

						{/* State */}
						<Col md={6}>
							<div className="mb-3">
								<label className="form-label">
									{/* {t("State")} <span className="text-danger">*</span> */}
								</label>
								<Select
									options={statesList}
									value={selectedState}
									onChange={handleStateChange}
									placeholder={t("Select state")}
									isSearchable
								/>
								{errors.state && (
									<div className="text-danger mt-1">{errors.state}</div>
								)}
							</div>
						</Col>
					</Row>

					<Row>
						{/* GST / State Code */}
						<Col md={6}>
							<div className="mb-3">
								<label className="form-label">{t("State Code (GST)")}</label>
								<Input
									type="text"
									value={newCustomerData.stateCode || ""}
									readOnly
									placeholder={t("Auto-filled")}
								/>
							</div>
						</Col>

						{/* City */}
						<Col md={6}>
							<div className="mb-3">
								<label className="form-label">{t("City")}</label>
								<Input
									type="text"
									value={newCustomerData.city || ""}
									onChange={(e) => onChange({ city: e.target.value })}
									placeholder={t("Enter city")}
								/>
							</div>
						</Col>
					</Row>
				</Form>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="primary" onClick={onSubmit}>
					{t("Create Customer")}
				</Button>
				<Button variant="secondary" onClick={handleModalHide}>
					{t("Cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default NewCustomerModal;
